export const ADMIN_TOKEN_NSP = "admin-token";
